import { render } from "./AchievementImage.vue?vue&type=template&id=f48d0e5a&scoped=true"
import script from "./AchievementImage.vue?vue&type=script&lang=js"
export * from "./AchievementImage.vue?vue&type=script&lang=js"

import "./AchievementImage.vue?vue&type=style&index=0&id=f48d0e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48d0e5a"]])

export default __exports__